/**
 * ReportsHubPage — the Reports area's landing page (PRD_DtrReport C1/C2).
 *
 * A permission-filtered grid of report cards from src/config/reportCards.js.
 * Cards render only when the user holds ALL of the card's `requires`
 * permissions (hasAllPermissions), matching each report route's requireAll
 * guard — so a card the user can see is always a card they can open.
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../icons/Icon';
import { useAuth } from '../../hooks/useAuth';
import { REPORT_CARDS } from '../../config/reportCards';

const ReportsHubPage = () => {
  const navigate = useNavigate();
  const { company, hasAllPermissions } = useAuth();

  const visibleCards = REPORT_CARDS.filter((card) => hasAllPermissions(card.requires));

  return (
    <div>
      <h1 style={{ fontSize: '1.25rem', fontWeight: 700, color: 'var(--ui-primary)', margin: '0 0 0.25rem 0' }}>
        Reports
      </h1>
      <p style={{ fontSize: '0.875rem', color: 'var(--ui-text-secondary)', margin: '0 0 1.5rem 0' }}>
        Predefined, printable reports generated from your company's records.
      </p>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
          gap: '16px',
        }}
      >
        {visibleCards.map((card) => (
          <button
            key={card.id}
            type="button"
            onClick={() => navigate(`/company/${company.slug}/${card.path}`)}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '12px',
              padding: '20px',
              background: 'var(--ui-surface)',
              border: '1px solid var(--ui-border)',
              borderRadius: '12px',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
              cursor: 'pointer',
              textAlign: 'left',
              fontFamily: 'var(--font-family-primary)',
            }}
          >
            <span style={{ color: 'var(--ui-primary)', flexShrink: 0, marginTop: '2px' }}>
              <Icon name={card.icon} size={22} />
            </span>
            <span>
              <span style={{ display: 'block', fontSize: '0.9375rem', fontWeight: 600, color: 'var(--ui-text)' }}>
                {card.label}
              </span>
              <span style={{ display: 'block', fontSize: '0.8125rem', color: 'var(--ui-text-secondary)', marginTop: '4px' }}>
                {card.description}
              </span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ReportsHubPage;
